import JobSkill from ".";

export const jobSkillRoutes = () => [
  {
    path: "/admin/job-skills",
    component: JobSkill,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];